import React from "react";
import InputBox from "../../components/InputBox";
import Button from "../../components/Button";
import { FaTimes } from "react-icons/fa";

function InventoryForm({
  showForm,
  handleShowForm,
  formData,
  setFormData,
  handleAddInventory,
  isProcessing,
  editMode,
  tableHeadersAndData,
}) {
  if (!showForm) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-5xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center p-6 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-[#002368]">
            {editMode ? "Edit Available Space" : "Add an Available Space"}
          </h3>
          <button
            onClick={handleShowForm}
            className="text-gray-500 hover:text-[#ff5003] transition-colors"
          >
            <FaTimes size={20} />
          </button>
        </div>

        <form className="flex flex-col gap-4 p-6" onSubmit={handleAddInventory}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {
              // form inputs
              tableHeadersAndData.map((item) => (
                <InputBox
                  key={item.header}
                  label={item.header}
                  name={item.data}
                  value={formData[item.data] || ""}
                  onChange={handleChange}
                  required={item.required}
                  placeholder={item.placeholder}
                  type={item.type}
                
                />
              ))
            }
          </div>

          <div className="flex justify-end gap-4 mt-6 pt-4 border-t border-gray-200">
            <Button
              label="Cancel"
              onClick={handleShowForm}
              className="bg-gray-100 text-gray-700 py-2 px-6 rounded-md hover:bg-gray-200 transition-colors duration-300"
            />
            <Button
              label={
                isProcessing ? "Processing..." : editMode ? "Update" : "Add"
              }
              type="submit"
              disabled={isProcessing}
              className="bg-[#002368] text-white py-2 px-6 rounded-md hover:bg-[#001a4d] transition-colors duration-300"
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export default InventoryForm;
